"use client";

import styled from "styled-components";

interface ButtonTextDivProps {
  gap?: number;
}

export const Button = styled.button`
  margin-left: 5px;
`;

export const ButtonTextDiv = styled.div<ButtonTextDivProps>`
  display: flex;
  gap: ${(props) => (props.gap ? `${props.gap}px` : "3px")};

  .item {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
